var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link",
    d: "M11.681,12.941l-2,2a3.253,3.253,0,0,1-2.389.985,3.362,3.362,0,0,1-3.375-3.375,3.253,3.253,0,0,1,.985-2.389l2-2,.788.788-2,2a2.258,2.258,0,0,0,1.6,3.86,2.179,2.179,0,0,0,1.6-.656l2-2Zm-3.335-.656L7.558,11.5,11.5,7.558l.788.788Zm4.6-.6-.788-.788,2-2a2.179,2.179,0,0,0,.656-1.6,2.265,2.265,0,0,0-3.86-1.6l-2,2L8.162,6.9l2-2a3.392,3.392,0,0,1,4.779,0,3.254,3.254,0,0,1,.985,2.39,3.253,3.253,0,0,1-.985,2.389Z",
    transform: "translate(-3.921 -3.921)",
    fill: "#8d8d8d"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.6b3b6153.svg";
export { ForwardRef as ReactComponent };